const ioTypes = {
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING',
  BOTH: 'BOTH',
};
export default ioTypes;
